<template>
  <div class="">
    <section-title content="Información General" :has-line="true" />
    <div class="p-3">
      <div class="mx-2">
        <div class="row">
          <div class="col-md-4">
            <label class="data-title mb-0">Dirección Web:</label>
            <validation-provider
              v-slot="{ errors }"
              name="webAddress"
              rules="url"
            >
              <custom-input
                v-model="model.websiteUrl"
                :custom-error-msg="'La dirección web es inválida.'"
                :error="errors[0]"
                placeholder="www.websitedomain.com"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="telephone"
              :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
            >
              <label class="data-title mb-0">Teléfono:</label>
              <custom-input
                v-model="model.phone"
                :custom-error-msg="'El teléfono es requerido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(xxx)xxx-xxxx"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <label class="data-title mb-0">Fax:</label>
            <validation-provider v-slot="{ errors }" name="fax" rules="phone">
              <custom-input
                v-model="model.fax"
                :custom-error-msg="'El fax no es valido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(xxx)xxx-xxxx"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div
            v-if="isMedicaidDocumentationWorkflowEnabled"
            class="col-md-4 my-2"
          >
            <custom-input-display
              v-if="isLocationTypeSchool"
              label="NPI LS DEPR:"
              :value="model.locationSchoolNationalIdentifier"
            />
            <validation-provider
              v-else
              ref="npiDeprObserver"
              v-slot="{ errors }"
              rules="required"
            >
              <div class="d-flex align-items-center">
                <custom-input
                  v-model="model.locationSchoolNationalIdentifier"
                  custom-error-msg="El NPI LS DEPR es requerido."
                  :disabled="isNpiDeprDisabled"
                  :error="errors[0]"
                  label="NPI LS DEPR:"
                />

                <div
                  class="ml-2"
                  :class="{
                    'mt-4': !errors?.length && editingNpiDepr,
                  }"
                >
                  <div v-if="editingNpiDepr">
                    <button
                      v-if="canCancelNpiDepr && initialNpiDepr"
                      class="ab-btn ab-btn-outline-danger mt-1 mr-2"
                      type="button"
                      @click="cancelEditNpiDepr"
                    >
                      <i class="fas fa-times-circle" />
                    </button>

                    <button
                      class="ab-btn ab-btn-success mt-1"
                      :disabled="
                        !!errors?.length ||
                          initialNpiDepr ==
                            model.locationSchoolNationalIdentifier
                      "
                      type="button"
                      @click="saveNpiDepr"
                    >
                      <i class="fas fa-save" />
                    </button>
                  </div>

                  <button
                    v-else
                    class="ab-btn ab-btn-success mt-1"
                    type="button"
                    @click="editNpiDepr"
                  >
                    <i class="fas fa-edit" />
                  </button>
                </div>
              </div>
            </validation-provider>
          </div>

          <div
            v-if="isMedicaidDocumentationWorkflowEnabled"
            class="col-md-4 my-2"
          >
            <validation-provider
              ref="npiObserver"
              v-slot="{ errors }"
              rules="required"
            >
              <div class="d-flex align-items-center">
                <custom-input
                  v-model="model.nationalIdentifier"
                  custom-error-msg="El NPI es requerido."
                  :disabled="isNpiDisabled"
                  :error="errors[0]"
                  label="NPI LS Proveedor:"
                />

                <div
                  class="ml-2"
                  :class="{
                    'mt-4': !errors?.length && editingNpi,
                  }"
                >
                  <div v-if="editingNpi">
                    <button
                      v-if="canCancelNpi && initialNpi"
                      class="ab-btn ab-btn-outline-danger mt-1 mr-2"
                      type="button"
                      variant="outline-danger mt-1 mr-2"
                      @click="cancelEditNpi"
                    >
                      <i class="fas fa-times-circle" />
                    </button>

                    <button
                      class="ab-btn ab-btn-success mt-1"
                      :disabled="
                        !!errors?.length ||
                          initialNpi == model.nationalIdentifier
                      "
                      type="button"
                      @click="saveNpi"
                    >
                      <i class="fas fa-save " />
                    </button>
                  </div>
                  <button
                    v-else
                    class="ab-btn ab-btn-success mt-1"
                    type="button"
                    @click="editNpi"
                  >
                    <i class="fas fa-edit " />
                  </button>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomInputDisplay from 'CustomInputDisplay';
import { ValidationProvider } from 'vee-validate';
export default {
  name: 'LocationServiceGeneralInfo',
  components: {
    SectionTitle,
    CustomInput,
    ValidationProvider,
    CustomInputDisplay,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isMedicaidDocumentationWorkflowEnabled: {
      type: Boolean,
      default: false,
    },
    isLocationTypeSchool: {
      type: Boolean,
      default: false,
    },
    initialNpi: {
      type: String,
      default: '',
    },
    initialNpiDepr: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editingNpi: false,
      canCancelNpi: false,
      editingNpiDepr: false,
      canCancelNpiDepr: false,
    };
  },
  watch: {
    initialNpi: {
      immediate: true,
      handler(val) {
        this.editingNpi = !val;
      },
    },
    initialNpiDepr: {
      immediate: true,
      handler(val) {
        this.editingNpiDepr = !val;
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isNpiDeprDisabled() {
      return !this.editingNpiDepr && !!this.initialNpiDepr;
    },
    isNpiDisabled() {
      return !this.editingNpi && !!this.initialNpi;
    },
    isSomePhoneFilledUp() {
      const phone = Boolean(this.model.phone);
      const fax = Boolean(this.model.fax);
      return fax || phone;
    },
  },
  methods: {
    editNpiDepr() {
      this.editingNpiDepr = true;
      this.canCancelNpiDepr = true;
    },
    cancelEditNpiDepr() {
      this.model.locationSchoolNationalIdentifier = this.initialNpiDepr || '';
      this.editingNpiDepr = false;
    },
    async saveNpiDepr() {
      const valid = await this.$refs.npiDeprObserver.validate();
      if (valid) {
        this.$emit(
          'save-npi-depr',
          this.model.locationSchoolNationalIdentifier,
          () => {
            this.editingNpiDepr = false;
          }
        );
      }
    },
    editNpi() {
      this.editingNpi = true;
      this.canCancelNpi = true;
    },
    cancelEditNpi() {
      this.model.nationalIdentifier = this.initialNpi || '';
      this.editingNpi = false;
    },
    async saveNpi() {
      const valid = await this.$refs.npiObserver.validate();
      if (valid) {
        this.$emit('save-npi', this.model.nationalIdentifier, () => {
          this.editingNpi = false;
        });
      }
    },
  },
};
</script>
